export const ASSIGNED_RESOURCES = ['products', 'clients', 'app_users']

export function emptyAssignedData() {
  return Object.fromEntries(
    ['products', 'clients', 'app_users'].map((resource) => [
      resource,
      {
        strategy: 'individual',
        selectionType: 'include',
        all: false,
        uids: [],
        items: [],
        qualifiers: {}
      }
    ])
  )
}

export function hydrateAssignedData(data = {}, resources = ASSIGNED_RESOURCES) {
  const result = emptyAssignedData()
  resources.forEach((resource) => {
    const input = data[resource] || {}
    result[resource] = {
      strategy: input.mode === 'qualifiers' ? 'qualifiers' : 'individual',
      selectionType: input.selection_type || 'include',
      all: input.mode === 'all',
      uids: input.uids || input.ids || [],
      items: (input.items || []).map((item) => ({ ...item, uid: item.uid || item.id })),
      qualifiers: input.qualifiers || {},
      total: input.total
    }
  })
  return result
}

export function serializeAssignedData(value, resources = ASSIGNED_RESOURCES) {
  const data = { ...emptyAssignedData(), ...value }
  return Object.fromEntries(
    resources.map((resource) => {
      const input = data[resource]
      if (resource !== 'app_users' && input.strategy === 'qualifiers') {
        const qualifiers = Object.fromEntries(
          Object.entries(input.qualifiers || {})
            .filter(([, values]) => values.length > 0)
            .sort(([left], [right]) => left.localeCompare(right))
            .map(([key, values]) => [key, [...new Set(values)].sort()])
        )
        return [
          resource,
          Object.keys(qualifiers).length ? { mode: 'qualifiers', qualifiers } : { mode: 'none' }
        ]
      }
      if (input.all) return [resource, { mode: 'all' }]
      const uids = [...new Set(input.uids || input.ids || [])].sort()
      const selectionType = resource === 'app_users' ? 'include' : input.selectionType || 'include'
      if (!uids.length) return [resource, { mode: selectionType === 'exclude' ? 'all' : 'none' }]
      return [resource, { mode: 'individual', selection_type: selectionType, uids }]
    })
  )
}

export function hasValidAssignedData(value, resources = ASSIGNED_RESOURCES) {
  const data = { ...emptyAssignedData(), ...value }
  return resources
    .filter((resource) => resource !== 'app_users')
    .every((resource) => {
      const input = data[resource]
      return (
        input.strategy !== 'qualifiers' ||
        Object.values(input.qualifiers || {}).every(Array.isArray)
      )
    })
}

export function hasAnyAssignedData(value, resources = ASSIGNED_RESOURCES) {
  return Object.values(serializeAssignedData(value, resources)).some(
    (selection) => selection.mode !== 'none'
  )
}

export function buildRbacUserSavePayload(form, profilePayload, resources = ASSIGNED_RESOURCES) {
  let assignedData = {}
  if (form.assignedDataDirty) {
    const current = serializeAssignedData(form.assignedData, resources)
    const initial =
      form.initialAssignedData && serializeAssignedData(form.initialAssignedData, resources)
    assignedData = Object.fromEntries(
      Object.entries(current).filter(
        ([resource, selection]) =>
          !initial || JSON.stringify(selection) !== JSON.stringify(initial[resource])
      )
    )
  }
  return {
    ...profilePayload,
    role_ids: form.roleIds,
    ...(Object.keys(assignedData).length ? { assigned_data: assignedData } : {})
  }
}
